import { render, staticRenderFns } from "./formGroupItem.vue?vue&type=template&id=47835ef3&scoped=true"
import script from "./formGroupItem.vue?vue&type=script&lang=js"
export * from "./formGroupItem.vue?vue&type=script&lang=js"
import style0 from "./formGroupItem.vue?vue&type=style&index=0&id=47835ef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47835ef3",
  null
  
)

export default component.exports